// src/components/ui/PageLoader.jsx
import React from "react";

export const PageLoader = () => (
  <div className="text-center p-5">
    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
      <span className="visually-hidden">Loading...</span>
    </div>
    <p className="text-muted mt-3">Please wait…</p>
  </div>
);
